import { BADGE_COLORS } from "../../../components/ui/badgeColors";
import { INVENTARIO_ESTADO } from "../constants";

const ESTADOS_ABIERTOS = [INVENTARIO_ESTADO.PENDIENTE, INVENTARIO_ESTADO.EN_CURSO];
const MS_DIA = 24 * 60 * 60 * 1000;

// "YYYY-MM-DD" como día LOCAL: new Date("2026-10-01") sería medianoche UTC, el día anterior en Canarias
const aDiaLocal = (fecha) => {
    const [anio, mes, dia] = String(fecha).slice(0, 10).split("-").map(Number);
    return new Date(anio, mes - 1, dia);
};

/**
 * Aviso de vencimiento de un inventario que aún se puede contar
 * @param {{fechaLimite?: string|null, estado: string}} inventario - Inventario con su fecha límite
 * @param {Date} [hoy] - Fecha de referencia (inyectable para tests)
 * @returns {{label: string, color: Object}|null} "Vencido" (rojo), "Hoy" o "Mañana" (ámbar), o null
 */
export const getAvisoVencimiento = (inventario, hoy = new Date()) => {
    if (!inventario?.fechaLimite || !ESTADOS_ABIERTOS.includes(inventario.estado)) return null;

    const inicioHoy = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
    const dias = Math.round((aDiaLocal(inventario.fechaLimite) - inicioHoy) / MS_DIA);

    if (dias < 0) return { label: "Vencido", color: BADGE_COLORS.RED };
    if (dias === 0) return { label: "Hoy", color: BADGE_COLORS.AMBER };
    if (dias === 1) return { label: "Mañana", color: BADGE_COLORS.AMBER };
    return null;
};
